module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "user-info-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student),
      expression: "student"
    }],
    staticClass: "user-profile"
  }, [_c('item-user-profile', {
    attrs: {
      "item-name": "姓名",
      "item-content": _vm.student.name
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "性别",
      "item-content": _vm.student.sex
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "生日",
      "item-content": _vm.student.birthday
    }
  }), _vm._v(" "), _c('item-user-profile', {
    attrs: {
      "item-name": "课次",
      "item-content": _vm.student.courseSummary
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "back-box"
  }, [_c('v-go-back-btn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-334b7cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/StudentProfileInfo.vue
// module id = 768
// module chunks = 1